/** @format */

import { useEffect, useState, useMemo } from "react";
import { Container, Spinner, Table } from "reactstrap";
import http from "../../../services/http";
import { getAPIURL, getVendorSettings } from "../../../services/helper";
import EODHeader from "./EODHeader";

const api_url = getAPIURL();

export default function EODByPayTypes({ register_id }) {
  const [register, setRegister] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRegisterReport();
  }, []);

  const fetchRegisterReport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setRegister(data);
      setTransactions(data.transactions || []);
    } catch (error) {
      console.error("Error fetching register report:", error);
    }
    setLoading(false);
  };

  const payTypeReport = useMemo(() => {
    const summary = {};

    (transactions || []).forEach((txn) => {
      const paymentType = txn.payment_type || "Unknown";
      const tax = parseFloat(txn.tax_collected || 0);
      const discount = parseFloat(txn.discount || 0);
      const orderTotal = parseFloat(txn.order_total || 0);

      if (!summary[paymentType]) {
        summary[paymentType] = {
          sales: 0,
          discounts: 0,
          tax: 0,
          total: 0,
        };
      }

      summary[paymentType].sales += orderTotal;
      summary[paymentType].discounts += discount;
      summary[paymentType].tax += tax;
      summary[paymentType].total += orderTotal + tax + discount;
    });

    return Object.entries(summary).map(([type, values]) => ({
      payment_type: type,
      ...values,
    }));
  }, [transactions]);

  if (loading || !register) return <Spinner color="primary" />;

  return (
    <div className="page-body">
      <Container className="mt-4">
        <EODHeader
          closed_at={register.closed_at}
          printLink={`/print/reports/eod-category/${register_id}`}
        />
        <hr />

        <div className="eod-paytype-report mt-5">
          <h4 className="text-center mb-3">
            End of Day Summary by Payment Type
          </h4>
          <Table bordered responsive striped>
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Sales</th>
                <th>Discounts</th>
                <th>Tax</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {payTypeReport.map((type, i) => (
                <tr key={i}>
                  <td>{type.payment_type}</td>
                  <td>${type.sales.toFixed(2)}</td>
                  <td>${type.discounts.toFixed(2)}</td>
                  <td>${type.tax.toFixed(2)}</td>
                  <td>${type.total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
}
